<template>
  <div class="randomizer-social" id="social">
    <div class="randomizer-social_col">
      <h2
        class="randomizer-social_header heading1"
        v-html="$c('Расскажи об акции друзьям %(br)s в социальных сетях!', { br: '<br />' })"
      />
    </div>
    <div class="randomizer-social_col">
      <ul class="randomizer-social_buttons">
        <li class="randomizer-social_buttons-item">
          <a
            :href="vkUrl"
            target="_blank"
            @click="socialApi"
            class="randomizer-social_button __vk"
          >
            <svg width="25" height="14" viewBox="0 0 25 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8625 9.814C21.8625 9.814 23.8029 11.7691 24.2829 12.6737C24.2923 12.6866 24.2995 12.701 24.3045 12.7163C24.5001 13.051 24.5481 13.3128 24.4521 13.5063C24.2901 13.8259 23.7417 13.9866 23.5557 14H20.1261C19.8873 14 19.3905 13.9361 18.7857 13.51C18.3237 13.1813 17.8641 12.6383 17.4189 12.1082C16.7541 11.3211 16.1793 10.6376 15.5973 10.6376C15.5229 10.6376 15.4509 10.6497 15.3813 10.6741C14.9409 10.8165 14.3817 11.4569 14.3817 13.1624C14.3817 13.6963 13.9689 14 13.6797 14H12.1089C11.5737 14 8.78732 13.8089 6.31651 11.1513C3.28891 7.89539 0.569708 1.36713 0.543308 1.3093C0.374108 0.88687 0.729308 0.656783 1.11331 0.656783H4.57651C5.04091 0.656783 5.19211 0.94287 5.29771 1.20035C5.42011 1.49557 5.87371 2.67583 6.61771 4.00217C7.82252 6.15939 8.56292 7.03713 9.15452 7.03713C9.26612 7.03713 9.37172 7.00913 9.47132 6.95191C10.2441 6.51791 10.1001 3.70148 10.0641 3.12139C10.0641 3.00878 10.0629 1.86443 9.66692 1.31052C9.38372 0.914261 8.90132 0.759652 8.60972 0.703652C8.68772 0.588 8.85332 0.411478 9.06572 0.308C9.59492 0.0389565 10.5513 0 11.5005 0H12.0273C13.0569 0.0146087 13.3233 0.0821739 13.6977 0.178957C14.4513 0.362174 14.4657 0.860696 14.3997 2.55774C14.375 3.11537 14.3618 3.67346 14.3601 4.23165C14.3601 4.36861 14.3541 4.522 14.3541 4.67722C14.3313 5.54765 14.3013 6.52887 14.9037 6.93122C14.9818 6.98081 15.072 7.00717 15.1641 7.0073C15.3729 7.0073 15.9981 7.0073 17.6937 4.03809C18.4377 2.72696 19.0137 1.18026 19.0533 1.064C19.0869 0.99887 19.1877 0.81687 19.3101 0.743217C19.4037 0.684174 19.5285 0.674435 19.5933 0.674435H23.6673C24.1113 0.674435 24.4125 0.743217 24.4713 0.91487C24.5697 1.19243 24.4521 2.04096 22.5921 4.60722C22.2789 5.03452 22.0041 5.40461 21.7629 5.72783C20.0769 7.98609 20.0769 8.0993 21.8625 9.814V9.814Z" fill="white"/>
            </svg>
            <span>{{ $c('Вконтакте') }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const randomRewards = namespace('randomRewards')

@Component({
  components: {}
})
class Social extends Vue {
  vkUrl = `https://vk.com/share.php?url=${encodeURIComponent(window.location.href)}`
  @randomRewards.Action('social') socialApi
}
export default Social
</script>

<style lang="scss">
  .randomizer-social {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-area: social;
    margin-bottom: 70px;
    @include media_tablet {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    &_col {
      width: 100%;
      display: block;
      @include media_tablet {
        align-items: flex-start;
      }
      @include media_desktop {
        display: flex;
        align-items: center;
        width: auto;
      }
    }
    &_header {
      @include media_desktop {
        padding-right: 50px;
        box-sizing: border-box;
        align-self: flex-end;
      }
    }
    &_message {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #999999;
      margin-top: 12px;
      @include media_desktop {
        font-size: 20px;
        line-height: 25px;
        margin-top: 0;
      }
    }
    &_buttons {
      display: flex;
      flex-direction: column;
      margin-top: 30px;
      @include media_tablet {
        width: 100%;
        margin-top: 0;
      }
      @include media_desktop {
        width: auto;
        flex-direction: row;
      }
      &-item {
        margin-left: 0;
        margin-bottom: 12px;
        @include media_desktop {
          margin-left: 20px;
          margin-bottom: 0;
        }
        &:first-child {
          margin-left: 0;
        }
      }
    }
    &_button {
      min-width: 200px;
      height: 50px;
      font-style: normal;
      font-weight: bold;
      font-size: 17px;
      line-height: 20px;
      letter-spacing: 0.75px;
      text-transform: uppercase;
      color: #FFFFFF;
      text-decoration: none;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50px;
      transition: background-color .3s ease;
      > svg {
        margin-right: 12px;
      }
      &.__vk {
        background: #5B8AB1;
        &:hover {
          background: rgba(#5B8AB1, .7);
        }
      }
    }
  }
</style>
